/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_Event_Group_QuestionInputs */

const en_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you want the marker times to be used as the start of the event or the end?`)
};

const fr_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous utiliser l'heure des marqueurs comme debut ou fin de l'evenement ?`)
};

const de_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollen die Markierungszeiten als Start- oder Endzeitpunkt des Ereignisses verwendet werden?`)
};

const it_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi che gli orari indicati vengano utilizzati come inizio o come fine dell'evento?`)
};

const ru_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы хотите, чтобы отмеченные временные метки использовались в качестве начала или окончания мероприятия?`)
};

const es_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres que los tiempos de los marcadores se utilicen como inicio o final del evento?`)
};

const zh_cn2_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您希望将标记时间用作活动的开始时间还是结束时间？`)
};

const ja_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカー時間をイベントの開始として使用するか、終了として使用するか?`)
};

const hi_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप चाहते हैं कि मार्कर समय का उपयोग कार्यक्रम की शुरुआत या अंत के रूप में किया जाए?`)
};

const pt_pt2_markers_create_event_group_question = /** @type {(inputs: Markers_Create_Event_Group_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja que os horários de referência sejam usados como início ou fim do evento?`)
};

/**
* | output |
* | --- |
* | "Do you want the marker times to be used as the start of the event or the end?" |
*
* @param {Markers_Create_Event_Group_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_event_group_question = /** @type {((inputs?: Markers_Create_Event_Group_QuestionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_Event_Group_QuestionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_create_event_group_question(inputs)
	if (locale === "de") return de_markers_create_event_group_question(inputs)
	if (locale === "it") return it_markers_create_event_group_question(inputs)
	if (locale === "ru") return ru_markers_create_event_group_question(inputs)
	if (locale === "es") return es_markers_create_event_group_question(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_create_event_group_question(inputs)
	if (locale === "ja") return ja_markers_create_event_group_question(inputs)
	if (locale === "hi") return hi_markers_create_event_group_question(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_create_event_group_question(inputs)
	return en_markers_create_event_group_question(inputs)
});